import { DeepPartial } from "@towersystems/roam-common/lib/shared-types";
import { PosApiResponseWithResult } from "../pos-api-response-with-result";

export class ReprintReceiptResponse extends PosApiResponseWithResult {
  constructor(input?: DeepPartial<ReprintReceiptResponse>) {
    super(input);
    // Re-apply after super(): subclass field declarations reset declared
    // properties to undefined once super() returns, wiping the values
    // BaseResponse copied. Re-assigning here restores the API payload.
    if (input) {
      Object.assign(this, input);
    }
    if (!this.ReceiptText) {
      this.ReceiptText = [];
    }
  }

  ReceiptText: string[];
  Merchant: string;
}
